import store from '@/state/store'

export default [

  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: false,
    },
    component: () => {

      return import('./views/dashboards/default')

      // var userRole = ('; '+document.cookie).split(`; userr=`).pop().split(';')[0];
      
      
      // if (!userRole || userRole == 0) {
      //   return import('./views/dashboards/default');
      // } else  if (userRole == 1) {
      //   return import('./views/reporting/reporting')
      // }
      
      
      
      // else if (userRole == 1) {
      //   /*return import('./views/reporting/supplier-reporting');*/ return import('./views/dashboards/default');
      // }else if(userRole == 2){
      //   /*return import('./views/dashboards/admin');*/ return import('./views/dashboards/default');
      // }

      
    }
  },


  // /product-page/ref-item-title
  {
    path: '/catalogue/:item-article-:ignored',
    name: 'product-page-cat',
    meta: { authRequired: false },
    component: () => import('./views/orders/product-page')
  },

   // /product-page/ref-item-title
   {
    path: '/catalogue/:section/:item-article-:ignored',
    name: 'product-page-sec',
    meta: { authRequired: false },
    component: () => import('./views/orders/product-page')
  },

  // /product-page/ref-item-title
  {
    path: '/catalogue/:section/:group/:item-article-:ignored',
    name: 'product-page-grp',
    meta: { authRequired: false },
    component: () => import('./views/orders/product-page')
  },






  // /product-page/<items-section>/<items-group>/<items-sub-group>/ref-item-title
  {
    path: '/catalogue/:section/:group/:subgroup/:item-article-:ignored',
    name: 'product-page-subgrp',
    meta: { authRequired: false },
    component: () => import('./views/orders/product-page')
  },

  {
    path: '/catalogue/',
    name: 'catalog',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/shop')
  },

  // /catalogue/<items-section>
  {
    path: '/catalogue/:section',
    name: 'catalog-section',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/shop')
  },


  // /catalogue/<items-section>/<items-group>
  {
    path: '/catalogue/:section/:group',
    name: 'catalog-section-group',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/shop')
  },

  // /catalogue/<items-section>/<items-group>/<items-sub-group>
  {
    path: '/catalogue/:section/:group/:subgroup',
    name: 'catalog-section-group-subgroup',
    meta: { authRequired: false },
    component: () => import('./views/dashboards/shop')
  },




  
    {
      path: '/ha/:specialgroup/',
      name: 'specialgroup',
      meta: { authRequired: false },
      component: () => import('./views/dashboards/shop-special-group')
    },
  
    // /ha/<special-group>/<items-section>
    {
      path: '/ha/:specialgroup/:section',
      name: 'specialgroup-section',
      meta: { authRequired: false },
      component: () => import('./views/dashboards/shop-special-group')
    },
  
  
    // /ha/<special-group>/<items-section>/<items-group>
    {
      path: '/ha/:specialgroup/:section/:group',
      name: 'specialgroup-section-group',
      meta: { authRequired: false },
      component: () => import('./views/dashboards/shop-special-group')
    },
  
    // /ha/<special-group>/<items-section>/<items-group>/<items-sub-group>
    {
      path: '/ha/:specialgroup/:section/:group/:subgroup',
      name: 'specialgroup-section-group-subgroup',
      meta: { authRequired: false },
      component: () => import('./views/dashboards/shop-special-group')
    },


    {
      path: '/paiement/etat',
      name: 'Check-Payment',
      meta: { authRequired: false },
      props(route) {
        return {  orderId: (String) (route.query.orderId) }
      },
     
      component: () => import('./views/check-payment/check-payment')
    },

    {
      path: '/cart-cadeaux/validee',
      name: 'payment-valid',
      meta: { authRequired: false },
      props(route) {
        return {  orderId: (String) (route.query.orderId) }
      },
      component: () => import('./views/orders/success-payment')
    },

    {
      path: '/commande/cash/validee',
      name: 'ordertate',
      meta: { authRequired: false },
      props(route) {
        return {  order_s_ref: (String) (route.query.order_s_ref) ,
                orderId: (String) (route.query.orderId) }
      },
      component: () => import('./views/orders/success-order-payment')
    },
    {
      path: '/commande/card/validee',
      name: 'ordertate',
      meta: { authRequired: false },
      props(route) {
        return {  order_s_ref: (String) (route.query.order_s_ref) ,
                orderId: (String) (route.query.orderId) }
      },
      component: () => import('./views/orders/success-order-payment')
    },
    {
      path: '/commande/validee',
      name: 'ordertate',
      meta: { authRequired: false },
      props(route) {
        return {  order_s_ref: (String) (route.query.order_s_ref) ,
                orderId: (String) (route.query.orderId) }
      },
      component: () => import('./views/orders/success-order-payment')
    },
  
  

  {
    path: '/cadeau',
    name: 'cadeau',
    meta: { authRequired: false },
    props(route) {
      return {  orderId: (String) (route.query.orderId) }
    },
     component: () => import('./views/gift-card/gift-card')
   },

  {
    path: '/panier',
    name: 'cart',
    meta: { authRequired: false },
    component: () => import('./views/orders/cart')
  },

  {
    path: '/paiement',
    name: 'paiement',
    meta: { authRequired: false },
    props(route) {
      return {state: (String) (route.query.state) }
    },
    component: () => import('./views/orders/paiement')
  },
  {
    path: '/comparateur',
    name: 'comparateur',
    meta: { authRequired: false },
    component: () => import('./views/comparator/comparator')
  },

  {
    path: '/signup',
    name: 'subscribe',
    component: () => import('./views/account/subscribe'),
    meta: { authRequired: false },

  },

  {
    path: '/compte',
    name: 'account',
    component: () => import('./views/account/account'),
    props(route) {
      return {  showOauth: (Boolean) (route.query.faegrnzmdwcsjvbxthqk) }
    },
    meta: { authRequired: false },

  },


  // redirect oAuth2

  {
    path: '/oauth2/:oAuth2',
    name: 'oauth2-facebook',
    props(route) {
      return {code: (String) (route.query.code)}
    },
    component: () => import('./views/account/subscribe'),
    meta: { authRequired: false },
  },





  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ path: '/espace-client' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/')
        )

        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/bienvenue',
    name: 'landing-page',
    meta: {
      isLandingPage: true
    },
    component: require('./views/utility/landing-page').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    component: require('./views/utility/404').default,
  },

  {
    path: '/404',
    component: require('./views/utility/404').default,
  },

  {
    path: '/actualites',
    name: 'news-actualites',
    meta: { authRequired: false },
    component: () => import('./views/news-actu/blog')
  },
  
  {
    path: '/actualites/:name',
    name: 'actualite-details',
    meta: { authRequired: false },
    component: () => import('./views/news-actu/blog-detalis')
  },

 

  // {
  //   path: '/articles',
  //   name: 'Add Items',
  //   meta: { authRequired: true },
  //   component: () => import('./views/stock/addNewItems')
  // },

  {
    path: '/espace-client',
    redirect: '/espace-client/accueil'
},

  {
    path: '/espace-client/:module',
    name: 'Espace Client',
    meta: { authRequired: true },
    component: () => import('./views/customer-account/index')
  },

  {
    path: '/nos-magasins',
    name: 'Nos Magasins',
    meta: { authRequired: false },
    component: () => import('./views/faq/shops-map')
  },

  {
    path: '/qui-sommes-nous',
    name: 'Qui Sommes Nous',
    meta: { authRequired: false },
    component: () => import('./views/faq/history')
  },

  {
    path: '/echanges-et-retours-article',
    name: 'Echange-retour',
    meta: { authRequired: false },
    component: () => import('./views/faq/echange-retour')
  },

  {
    path: '/mentions-legales-cgv',
    name: 'Mentions-Legales',
    meta: { authRequired: false },
    /*props(route) {
      return {propFilter: (String) (route.query.filter), propGroup: (Number) (route.query.group), propSubGroup: (Number) (route.query.subgroup),   propFilterSize: (Number) (route.query.fsize)}
    },*/
    component: () => import('./views/faq/faq')
  },

  {
    path: '/contacter-nous',
    name: 'contact-us',
    meta: { authRequired: false },
    /*props(route) {
      return {propFilter: (String) (route.query.filter), propGroup: (Number) (route.query.group), propSubGroup: (Number) (route.query.subgroup),   propFilterSize: (Number) (route.query.fsize)}
    },*/
    component: () => import('./views/faq/contact-us')
  },

  


]
